module.exports = __webpack_public_path__ + "img/new_head_portrait.8f2d26c5.png";